import EstoqueService from "@/services/EstoqueService"
import { router } from "@/router"
import { add } from "lodash"
import store from '@/store'

export const actions = {
    cadastrarEstoque: ({ commit, dispatch }) => {
        commit('setEstoque', {
            nome: "",
            descricao: "",
            principal: false
        })

        dispatch('setModalCadastroEstoque', true)

    },
    async listarEstoque ({ commit }) {
        if(store.getters.getListarEstoque == false){
            commit('setListarEstoque', true)
            commit('setOverlay', true)
            await EstoqueService.listar()
            .then(res => {
                commit('setListarEstoque', false)
                commit('setEstoques', res.data)
                commit('setOverlay', false)
            })
            .catch(e => {
                console.log(e)
                commit('setOverlay', false)
            })
        }
        
    },
    visualizarEstoque: ({ commit, dispatch }, data) => {
        commit('setEstoque', data)
        dispatch('setModalCadastroEstoque', true)
    },
    salvarEstoque: ({ commit, dispatch }, data) => {
        dispatch('setModalCadastroEstoque', false)
        commit('setOverlay', true)
        EstoqueService.salvar(data)
            .then(res => {
                commit('addEstoque', res.data)
                dispatch('listarEstoque')
                commit('setOverlay', false)
                commit('snackbarSuccess', 'Estoque cadastrado.')
            })
            .catch(e => {
                console.log(e)
                commit('snackbarError', 'Erro ao cadastrar cargo.')
            })
    },
    atualizarEstoque: ({ commit, dispatch }, data) => {
        dispatch('setModalCadastroEstoque', false)
        commit('setOverlay', true)
        EstoqueService.atualizar(data)
            .then(res => {
                dispatch('listarEstoque')
                commit('setOverlay', false)
                commit('snackbarInfo', 'Estoque atualizado.')
            })
            .catch(e => {
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao atualizar cargo.')
            })
    },
    excluirEstoque: ({ commit, dispatch }, data) => {
        dispatch('setModalCadastroEstoque', false)
        commit('setOverlay', false)
        EstoqueService.excluir(data.id)
            .then(res => {
                // dispatch('listarEstoque')
                commit('removeEstoque', data)
                commit('setOverlay', false)
                commit('snackbarError', 'Estoque excluído.')
            })
            .catch(e => {
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao excluir cargo.')
            })
    },
    setModalCadastroEstoque: ({ commit }, status) => {
        commit('setModalCadastroEstoque', false)
        setTimeout(() => {
            commit('setModalCadastroEstoque', status)
        }, 100);
    },
    setModalExcluirEstoque: ({ commit }, status) => {
        commit('setModalExcluirEstoque', false)
        setTimeout(() => {
            commit('setModalExcluirEstoque', status)
        }, 100);
    },
    setModalImprimirEstoque: ({ commit }, status) => {
        commit('setModalImprimirEstoque', false)
        setTimeout(() => {
            commit('setModalImprimirEstoque', status)
        }, 100);
    },
    setModalMovimentacaoEstoque: ({ commit }, status) => {
        commit('setModalMovimentacaoEstoque', false)
        setTimeout(() => {
            commit('setModalMovimentacaoEstoque', status)
        }, 100);
    },
    transferirEstoque: ({ commit }, data) => {
        commit('setOverlay', true)
        EstoqueService.transferir(data)
            .then(res => {
                commit('setOverlay', false)
                commit('snackbarSuccess', 'Transferêcia realizada com sucesso.')
            })
            .catch(e => {
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao transferir estoque.')
            })
    }

}

export default {}